import { useEffect, useRef, useState } from "react";
import { FaSearch, FaBell, FaUserCircle, FaCalendarAlt } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import { getChatHistoryAPI } from '../../serverApi/server'
import { getFormattedDateLabel, getCookie } from '../../components/Helper/Helpers'
// import newLogo from '../../assets/newStalbansLogo.png';
import newLogo from '../../assets/newStalbansLogo.png'


export default function AdminChatPage({ sessionId, currentCustomer, setCurrentCustomerMessage, customers }) {
  const [allMessages, setAllMessages] = useState({});
  const [message, setMessage] = useState("");
  const socket = useRef(null);
  const scrollRef = useRef(null);
  const userId = getCookie('_puisap');

  useEffect(() => {
    if (!sessionId) return;
    setCurrentCustomerMessage(message);
    let reconnectTimeout = null;
    let shouldReconnect = true;
    const getChatMessageHistory = async (sessionId) => {
      const res = await getChatHistoryAPI(sessionId);
      if (res.data.client_status_code === 200) {
        setAllMessages(res.data.chat_message_serializer);
      }
    };

    const connectWebSocket = () => {
      const ws = new WebSocket(`wss://www.stalbansprinting.com/ws/chat/${sessionId}/`);
      socket.current = ws;

      ws.onopen = () => {
        console.log("WebSocket connected ✅");
        ws.send(JSON.stringify({ type: 'mark_read' }));
      };

      ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        if (data.type === "message_deleted") {
          const messageId = data.message_id;
          setAllMessages((prev) => {
            const updated = { ...prev };
            for (const date in updated) {
              updated[date] = updated[date].filter((msg) => msg.id !== messageId);
            }
            return updated;
          });
          return;
        }
        
        if (data.session_id !== sessionId) return;
        const now = new Date();
        const options = {
          timeZone: 'America/New_York',
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
        };
        const estDate = new Intl.DateTimeFormat('en-US', options).format(now);
        data.created_at = now.toISOString().replace('Z', '+00:00');
        setAllMessages((prev) => {
          const updated = { ...prev };
          if (updated[estDate]) {
            const isDuplicate = updated[estDate].some(
              (msg) => msg.message === data.message && msg.sender === data.sender && msg.timestamp === data.timestamp
            );
            if (!isDuplicate) {
              updated[estDate] = [...updated[estDate], data];
            }
          } else {
            updated[estDate] = [data];
          }
          return updated;
        });
      };
      ws.onclose = (e) => {
        console.warn("WebSocket closed ❌", e);
        if (shouldReconnect) {
          console.log("Reconnecting WebSocket in 3 seconds...");
          reconnectTimeout = setTimeout(connectWebSocket, 1000);
        }
      };

      ws.onerror = (e) => {
        console.error("WebSocket error 💥", e);
      };
    };
    getChatMessageHistory(sessionId);
    connectWebSocket();
    const pingInterval = setInterval(() => {
      if (socket.current?.readyState === WebSocket.OPEN) {
        socket.current.send(JSON.stringify({ type: 'ping' }));
      }
    }, 3000);
    return () => {
      shouldReconnect = false;
      clearTimeout(reconnectTimeout);
      clearInterval(pingInterval);
      // socket.current?.close();
    };
  }, [sessionId, customers]);

  const sendMessage = () => {
    if (message.trim()) {
      socket.current.send(JSON.stringify({ message: message, sender: "admin", user_id: userId }));
      setMessage("");
    }
  };

  const handleDeleteMessage = (seletedMessage) => {
    if (!seletedMessage.id) return;
    try {
      socket.current.send(
        JSON.stringify({
          type: "delete",
          message_id: seletedMessage.id,
          sender: "user",
        })
      );
    } catch (err) {
      console.error("WebSocket delete error:", err);
    }
  }

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [allMessages]);

  return (
    <>
      <div className="flex-1 flex flex-col bg-[#0f1a43]">
        <div className="p-4 border-b border-gray-700 flex justify-between items-center bg-[#0b1437]">
          <div>
            <div className="text-md font-semibold">{currentCustomer.user_full_name ? currentCustomer.user_full_name : currentCustomer.chat_user_id ? `New User - ${currentCustomer.chat_user_id}` : sessionId}</div>
            {/* <div className="text-sm text-gray-400">Last Seen 10:30pm ago</div> */}
          </div>
          <div className="flex gap-3">
            <FaSearch />
            <FaBell />
            <FaUserCircle />
          </div>
        </div>
        <div ref={scrollRef} className="flex-1 p-6 overflow-y-auto space-y-4 pr-1 custom-scrollbar">
          {Object.keys(allMessages).length === 0 ? (
            <div className="flex flex-col items-center h-full text-gray-500 py-4">
              <img src={newLogo} className="mb-4" alt="No messages" />
              <p className="text-center">No messages yet</p>
            </div>
          ) : (
            Object.entries(allMessages).map(([date, msgs]) => (
              <div key={date}>
                <div className="text-center text-xs text-gray-400 mb-2">
                  {getFormattedDateLabel(date)}
                </div>
                <div className="space-y-2">
                  {msgs.map((msg, i) => {
                    const time = new Date(msg.timestamp || msg.created_at).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                      timeZone: "America/New_York",
                    });
                    return (
                      <div
                        key={msg.id || i}
                        className={`flex ${msg.sender === "admin" ? "justify-end" : "justify-start"}`}
                      >
                        <div
                          className={`relative group max-w-md px-4 py-2 rounded-lg text-sm break-words whitespace-pre-wrap ${
                            msg.sender === "admin"
                              ? "bg-[#5a78ff] text-white"
                              : "bg-[#1a254f] text-white"
                          }`}
                        >
                          {msg.message}
                          <div className="text-[10px] text-right opacity-70 mt-1">{time}</div>
                          {msg.sender === 'admin' && (
                            <MdDeleteForever 
                              size={20}
                              onClick={() => handleDeleteMessage(msg)}
                              className="absolute cursor-pointer top-1 right-1 opacity-0 group-hover:opacity-100 text-white text-xs hover:text-red-300 transition"
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          )}
        </div>
        <div className="p-4 border-t border-gray-700 bg-[#0b1437]">
          <div className="flex items-center space-x-3">
            <input
              type="text"
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                  if (e.key === 'Enter' && message.trim()) {
                    sendMessage();
                  }
              }}
              className="flex-1 px-4 py-2 rounded-full text-black"
            />
            <button onClick={sendMessage} className="bg-blue-500 p-2 rounded-full text-white">
              <IoMdSend size={20} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

